var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"math-lessons-page"},[_c('chapter',{staticClass:"ribbon",attrs:{"tag":"h1"}},[_vm._v("Предмети")]),_c('math-lessons')],1)}
var staticRenderFns = []

export { render, staticRenderFns }